import { Box, TableContainer, Paper } from '@mui/material'
import { SALES_TABLE_MAX_HEIGHT } from '../constants'
import TableLoadingOverlay from './TableLoadingOverlay'

function ReportTableContainer({ loading, hasRows, children }) {
  const showOverlay = loading && hasRows

  return (
    <Box sx={{ position: 'relative' }}>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: SALES_TABLE_MAX_HEIGHT,
          overflow: 'auto',
          boxShadow: 'none',
        }}
      >
        {children}
      </TableContainer>
      {showOverlay && <TableLoadingOverlay />}
    </Box>
  )
}

export default ReportTableContainer
